import React from 'react';
import { Button, useScreenQuery } from 'playup-web-core';
import styled from 'styled-components';

import ReusableModalPlain from '../ReusableModal/ReusableModalPlain';
import SlideNavigator from './SlideNavigator';
import GlobalContext from '../../contexts/GlobalContext';
import appConfig from '../../appConfig';
import SlideContent from './SlideContent';
import { SlidesConfig } from './SlidesConfig';

const slides =
	appConfig.portal.whatsNewSlidesVersion && SlidesConfig[appConfig.portal.whatsNewSlidesVersion]
		? SlidesConfig?.[appConfig.portal.whatsNewSlidesVersion]
		: [];

const WhatsNewModal = ({ onClose }: Props) => {
	const { setWhatsNewShownVersion, whatsNewShownVersion } = React.useContext(GlobalContext);
	const [slideIndex, setSlideIndex] = React.useState(0);
	const { isSmall } = useScreenQuery();

	const handleNext = () => {
		const nextIndex = (slideIndex + 1) % slides.length;
		if (nextIndex === 0) {
			onClose();
			setWhatsNewShownVersion(appConfig.portal.whatsNewSlidesVersion);
		}
		setSlideIndex(nextIndex);
	};

	const alreadyShown = appConfig.portal.whatsNewSlidesVersion === whatsNewShownVersion;

	return (
		<StyledModal
			desktopHeight={window.innerHeight * 0.8}
			desktopWidth={((window.innerHeight * 0.8) / 786) * 860}
			isSmall={isSmall}
			wrapperStyle={{
				alignItems: isSmall ? 'flex-end' : undefined,
			}}
		>
			<ContentContainer>
				<Title>
					<h1>What's New</h1>
				</Title>
				<SlideContent slides={slides} currentIndex={slideIndex} />
			</ContentContainer>
			<ActionButtonContainer isSmall={isSmall}>
				<SlideNavigator currentIndex={slideIndex} onPress={setSlideIndex} length={slides.length} />
				<Footer>
					<Button
						style={{
							height: '50px',
							width: isSmall ? '90%' : '40%',
						}}
						kind="white"
						onClick={handleNext}
					>
						{slides.length - 1 === slideIndex ? 'Close' : 'Next'}
					</Button>
					{alreadyShown && (
						<Button
							style={{
								height: '50px',
								width: isSmall ? '90%' : '40%',
							}}
							kind="blackslate"
							onClick={onClose}
						>
							Close
						</Button>
					)}
				</Footer>
			</ActionButtonContainer>
		</StyledModal>
	);
};

interface Props {
	onClose: () => void;
}
const Title = styled.div({
	height: 'calc(calc(80vh * .9) * .05)',
	textAlign: 'center',
	alignItems: 'center',
	display: 'flex',
	justifyContent: 'center',
});
const Footer = styled.div({
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
	flexDirection: 'column',
	width: '100%',
});
export default WhatsNewModal;
const ContentContainer = styled.div({
	display: 'flex',
	flexDirection: 'column',
});
const ActionButtonContainer = styled.div<{ isSmall: boolean }>(({ isSmall }) => ({
	display: 'flex',
	flexDirection: 'column',
	height: isSmall ? '100%' : 'calc(calc(80vh * .9) * .15)',
	justifyContent: isSmall ? 'flex-end' : 'unset',
	paddingBottom: isSmall ? '20px' : 'unset',
}));
const StyledModal = styled(ReusableModalPlain)<{ isSmall: boolean; desktopWidth: number; desktopHeight: number }>`
	height: ${({ isSmall, desktopHeight }) => (isSmall ? '100vh' : desktopHeight + 'px')};
	width: ${({ isSmall, desktopWidth }) => (isSmall ? '100%' : desktopWidth + 'px')};
	text-align: center;
	color: black;
	overflow: auto;
	display: flex;
	flex-direction: column;

	h1 {
		font-size: 20px;
		font-weight: 600;
	}
`;
